import { Avatar, Group, Switch, Text } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function UserRow({ row }) {

    return (
        <Group gap="sm">
            <Avatar size={30} src={row?.image?.url} radius={30} />
            <Text
                tt="capitalize"
                fz="sm" fw={500}>
                {row?.name}
            </Text>
        </Group>
    )
}

export default UserRow